








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  @Prop() private maintitle!: string;
  @Prop() private subtitle!: string;
  @Prop({ default: 'left' }) private place!: string; // left, center
}
